// @flow
import type {Element} from 'react'
import React from 'react'

type Props = {
  isSubmittingAllowed: boolean,
}

function SubmitButton({isSubmittingAllowed}: Props): Element<"button"> {
  return (
    <button
      className="app-search__button"
      type={isSubmittingAllowed ? 'submit' : 'button'}
      title={I18n.t('nav.search')}
    >
      <i className="fa-solid fa-search" />
    </button>
  )
}

export default SubmitButton
